import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Communication } from '../../communications/communication.interface';

export class CallService {
   async callCandidate(
      caniddateId: number,
      hitId?: number,
      phoneNumber?: string,
      preventVoicemail?: boolean,
   ): Promise<ApiResource<Communication>> {
      const response = await http.post<ApiResource<Communication>>(`/candidates/${caniddateId}/call`, {
         hit_id: hitId,
         phone_number: phoneNumber,
         prevent_voicemail: preventVoicemail,
      });
      return response.data;
   }
}
